module.exports = __webpack_public_path__ + "static/media/atividade-coletiva-menu.ac301a7f.webp";